// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)
 *
 * Copyright © 2015-present Flatlogic, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

 .root{
  margin-top: 130px;
}
 
 .usersTable {
   th,
   td {
     border-color: white;
   }
 
   thead {
     border-bottom: 1px solid #e9ecef; /* Assuming \$gray-200 is #e9ecef */
   }
 }


 .custom-widget {
  border: 1px solid #e7e5e5; /* Light gray border */
  border-radius: 5px; /* Rounded corners */
 
  background: #fff; /* Optional: Adds white background */
 
}



.custom-card {
  background-color: white;
  border: 1px solid #e7e5e5; /* Light gray border */
  border-radius: 5px; /* Rounded corners */
 

}



.widget-separator {
  border: 0;
  height: 1px;
  background-color: #616060; /* Light gray separator */
 
}

@media (max-width: 576px) {
  .dashboard h2 {
    font-size: 1.5rem;
  }
  
  .dashboard h5 {
    font-size: 1.1rem;
  }
  
  .dashboard h6 {
    font-size: 1rem;
  }
  
  .dashboard .card {
    padding: 0.75rem !important;
  }
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  display: block;
}

.styled-table {
  min-width: 600px;
  width: 100%;
}

/* Add these new styles */
.bg-white {
  width: 100%;

  overflow: hidden; /* Contains the floating elements */
}

@media (max-width: 768px) {
  .bg-white {
    margin: 0;
    padding: 1rem !important;
  }
}





.assessment-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 10px;
 
  margin: 0 auto;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.card-header h3 {
  font-size: 1.5rem;
  color: #2d3748;
  margin: 0;
}

.card-actions {
  display: flex;
  gap: 12px;
}

.btn-primary {
  background-color: #F3903F;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  background-color: #f18024;
  transform: translateY(-1px);
}

.btn-outline {
  background: transparent;
  color: #F3903F;
  border: 1px solid #F3903F;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-outline:hover {
  background-color: #f5f3ff;
  transform: translateY(-1px);
}

.card-content {
  border-top: 1px solid #e2e8f0;
  padding-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;CAED;EACC,iBAAiB;AACnB;;CAEC;GACE;;KAEE,mBAAmB;GACrB;;GAEA;KACE,gCAAgC,EAAE,kCAAkC;GACtE;CACF;;;CAGA;EACC,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB,EAAE,oBAAoB;;EAExC,gBAAgB,EAAE,oCAAoC;;AAExD;;;;AAIA;EACE,uBAAuB;EACvB,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB,EAAE,oBAAoB;;;AAG1C;;;;AAIA;EACE,SAAS;EACT,WAAW;EACX,yBAAyB,EAAE,yBAAyB;;AAEtD;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,WAAW;;EAEX,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA;EACE;IACE,SAAS;IACT,wBAAwB;EAC1B;AACF;;;;;;AAMA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;;EAEb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":["/**\n * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)\n *\n * Copyright © 2015-present Flatlogic, LLC. All rights reserved.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE.txt file in the root directory of this source tree.\n */\n\n .root{\n  margin-top: 130px;\n}\n \n .usersTable {\n   th,\n   td {\n     border-color: white;\n   }\n \n   thead {\n     border-bottom: 1px solid #e9ecef; /* Assuming $gray-200 is #e9ecef */\n   }\n }\n\n\n .custom-widget {\n  border: 1px solid #e7e5e5; /* Light gray border */\n  border-radius: 5px; /* Rounded corners */\n \n  background: #fff; /* Optional: Adds white background */\n \n}\n\n\n\n.custom-card {\n  background-color: white;\n  border: 1px solid #e7e5e5; /* Light gray border */\n  border-radius: 5px; /* Rounded corners */\n \n\n}\n\n\n\n.widget-separator {\n  border: 0;\n  height: 1px;\n  background-color: #616060; /* Light gray separator */\n \n}\n\n@media (max-width: 576px) {\n  .dashboard h2 {\n    font-size: 1.5rem;\n  }\n  \n  .dashboard h5 {\n    font-size: 1.1rem;\n  }\n  \n  .dashboard h6 {\n    font-size: 1rem;\n  }\n  \n  .dashboard .card {\n    padding: 0.75rem !important;\n  }\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n  display: block;\n}\n\n.styled-table {\n  min-width: 600px;\n  width: 100%;\n}\n\n/* Add these new styles */\n.bg-white {\n  width: 100%;\n\n  overflow: hidden; /* Contains the floating elements */\n}\n\n@media (max-width: 768px) {\n  .bg-white {\n    margin: 0;\n    padding: 1rem !important;\n  }\n}\n\n\n\n\n\n.assessment-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  padding: 10px;\n \n  margin: 0 auto;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.card-header h3 {\n  font-size: 1.5rem;\n  color: #2d3748;\n  margin: 0;\n}\n\n.card-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-primary {\n  background-color: #F3903F;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #f18024;\n  transform: translateY(-1px);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #F3903F;\n  border: 1px solid #F3903F;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-outline:hover {\n  background-color: #f5f3ff;\n  transform: translateY(-1px);\n}\n\n.card-content {\n  border-top: 1px solid #e2e8f0;\n  padding-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
